import React from 'react';

const Icon = () => (
  <svg
    width="66"
    height="20"
    viewBox="0 0 66 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <rect width="66" height="20" rx="2" fill="#F3F5F7" />
    <path
      d="M10.52 13.5201H7.00002C6.68002 13.5201 6.52002 13.3601 6.52002 13.0401V7.04006C6.52002 6.72006 6.68002 6.56006 7.00002 6.56006H15C15.32 6.56006 15.48 6.72006 15.48 7.04006V9.52006"
      stroke="var(--text-color-2)"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 6.71997L11 9.99997L7 6.71997"
      stroke="var(--text-color-2)"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.4399 11.1201L15.5599 14.2401"
      stroke="var(--text-color-2)"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.5599 11.1201L12.4399 14.2401"
      stroke="var(--text-color-2)"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.71 6.13C26.96 6.49 27.32 7.11 27.52 7.5L26.86 7.79C26.66 7.38 26.34 6.78 26.07 6.4L26.71 6.13ZM27.85 5.71C28.11 6.08 28.49 6.71 28.67 7.07L28.02 7.35C27.81 6.93 27.48 6.35 27.2 5.98L27.85 5.71ZM21.06 10.95C21.5 9.88 21.9 8.41 22.03 7.2L23.17 7.44C23.09 7.69 23 8.07 22.96 8.28C22.82 8.94 22.47 10.38 22.08 11.36C21.71 12.3 21.15 13.38 20.6 14.16L19.51 13.7C20.14 12.87 20.72 11.81 21.06 10.95ZM25.99 10.65C25.6 9.61 24.97 8.18 24.54 7.43L25.58 7.09C25.98 7.83 26.64 9.28 27.05 10.3C27.43 11.25 27.96 12.81 28.23 13.75L27.08 14.12C26.82 13.03 26.4 11.72 25.99 10.65ZM34.69 5.93C34.64 6.29 34.63 6.51 34.63 6.75C34.63 7 34.63 7.77 34.63 8.13H33.54C33.54 7.72 33.54 7 33.54 6.75C33.54 6.51 33.53 6.29 33.48 5.93H34.69ZM38.08 7.94C38.02 8.12 37.95 8.43 37.91 8.63C37.76 9.5 37.48 10.62 36.95 11.56C36.18 12.94 34.75 13.98 32.94 14.46L32.12 13.52C32.51 13.45 32.96 13.33 33.32 13.19C34.25 12.87 35.25 12.19 35.84 11.31C36.37 10.51 36.66 9.41 36.76 8.54H31.45C31.45 8.93 31.45 9.88 31.45 10.19C31.45 10.39 31.46 10.67 31.48 10.85H30.39C30.42 10.64 30.43 10.35 30.43 10.12C30.43 9.8 30.43 8.73 30.43 8.37C30.43 8.16 30.43 7.79 30.39 7.57C30.7 7.6 31 7.61 31.36 7.61H36.65C37.04 7.61 37.25 7.57 37.4 7.52L38.08 7.94ZM41.63 6.56C42.33 7.03 43.62 8.07 44.19 8.65L43.39 9.46C42.88 8.92 41.63 7.84 40.89 7.34L41.63 6.56ZM40.6 13.24C42.26 13 43.56 12.43 44.52 11.85C46.14 10.86 47.39 9.36 47.99 8.07L48.6 9.17C47.89 10.46 46.65 11.83 45.1 12.79C44.09 13.41 42.82 14 41.26 14.28L40.6 13.24ZM57.3947 7.28C57.3247 7.37 57.1747 7.63 57.1047 7.79C56.7047 8.76 55.9447 10.15 55.1047 11.1C53.9847 12.37 52.5247 13.58 50.9547 14.31L50.1447 13.46C51.7547 12.85 53.2647 11.64 54.2547 10.54C54.9247 9.78 55.6047 8.68 55.8447 7.9C55.4647 7.9 52.5447 7.9 52.1647 7.9C51.7847 7.9 51.2347 7.95 51.0847 7.96V6.83C51.2747 6.86 51.8647 6.89 52.1647 6.89C52.6147 6.89 55.4747 6.89 55.8847 6.89C56.2547 6.89 56.5747 6.85 56.7547 6.79L57.3947 7.28ZM55.2347 10.45C56.2947 11.32 57.6647 12.76 58.3347 13.58L57.4447 14.35C56.7147 13.37 55.5747 12.13 54.5047 11.17L55.2347 10.45Z"
      fill="var(--text-color-2)"
    />
  </svg>
);

export default Icon;
